// extracted by mini-css-extract-plugin
module.exports = {"module":"GroupStyles_module__3KKyv","heading":"GroupStyles_heading__3xC5P","fullBleed":"GroupStyles_fullBleed__3BZd8"};